var Questions_num;
var inerval = setInterval;




function checkQuizLength() {
    let Questions_length = $('.quiz .questions .quest').length;


    if (Questions_length < 2) {
        $('.quiz').find('.nextButton').addClass('d-none').hide();
        $('.quiz').find('.submitButton').removeClass('d-none').show();

    } else {
        $('.quiz').find('.submitButton').removeClass('d-none').hide();
        $('.quiz').find('.nextButton').removeClass('d-none').show();


    }
}
checkQuizLength()



$("body").delegate(".quiz .skipquizButton ,.quiz .continueButton", "click", function() {
    // $(this).parent().closest('.quiz').remove();
    let el = $(this).parent().closest('.quiz');
    el.animate({ opacity: '0' }, 150, function() {
        el.animate({ height: '0px' }, 150, function() {
            el.remove();
        });
    });

});


$("body").delegate(".startquizButton", "click", function() {
    Questions_num = $('.quiz .questions .quest').length;

    $(this).parent().closest('.quiz').find('.start, .first-step').hide();
    $(this).parent().closest('.quiz').find('.questions').removeClass('d-none').show();

    $(this).parent().closest('.quiz').find('.questions .quest').eq(0).addClass('active').removeClass('d-none').show();

    if (Questions_num > 1) {
        $(this).parent().closest('.quiz').find('.nextButton').removeClass('d-none').show();
    } else {
        $(this).parent().closest('.quiz').find('.submitButton').removeClass('d-none').show();

    }

});


$("body").delegate(".nextButton", "click", function() {
    let activeques = $(this).parent().closest('.quiz').find('.questions .quest.active');
    let next = activeques.next('.quest');

    $(this).parent().closest('.quiz').find('.prevButton').removeClass('d-none')
    if (next) {

        activeques.removeClass('active').addClass('d-none').hide();
        next.addClass('active').removeClass('d-none').show();
        if (next.next('.quest').length < 1) {
            $(this).parent().closest('.quiz').find('.nextButton').addClass('d-none')
            $(this).parent().closest('.quiz').find('.submitButton').removeClass('d-none').show();

        }
    }



    //start quiz-progress
    let activeIndex = $(this).parent().closest('.quiz').find('.questions .quest.active').index() + 1;
    quizProgress(activeIndex)
        //end quiz-progress
})

$("body").delegate(".prevButton", "click", function() {


    let activeques = $(this).parent().closest('.quiz').find('.questions .quest.active');
    let prev = activeques.prev('.quest');

    $(this).parent().closest('.quiz').find('.nextButton').removeClass('d-none')
    if (prev) {

        activeques.removeClass('active').addClass('d-none').hide();
        prev.addClass('active').removeClass('d-none').show();

        if (prev.prev('.quest').length < 1) {
            $(this).parent().closest('.quiz').find('.prevButton').addClass('d-none')

        }
    }

    //start quiz-progress
    let activeIndex = activeques.index();
    quizProgress(activeIndex)
        //end quiz-progress

})


//to show score
$("body").delegate(".submitButton", "click", function() {


    $(this).parent().closest('.quiz').find('.start,.nav-btn ,.submitButton,.first-step ,.questions').hide();
    $(this).parent().closest('.quiz').find('.continueButton ,.score').removeClass('d-none').show();

    clearInterval(inerval)


})




//timer
function startTimer(duration, display) {
    var timer = duration,
        minutes, seconds;
    inerval = setInterval(function() {
        minutes = parseInt(timer / 60, 10);
        seconds = parseInt(timer % 60, 10);

        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;

        display.textContent = minutes + ":" + seconds;

        if (--timer < 0) {
            clearInterval(inerval)
                //  timer = duration;
        }
    }, 1000);
}
if ($('#time').length > 0) {


    var fiveMinutes = 60 * 2,
        display = document.querySelector('#time');
    startTimer(fiveMinutes, display);
}